/**
 * Points as display text: at most two decimals, no trailing zeros ("40",
 * "2.5", "13.33"). Competition points are fractional (problem points times
 * the event's multiplier and the test case share), so a raw float would show
 * noise such as 0.7000000000000001. Empty for missing points.
 */
export const formatPoints = (points: number | null | undefined): string =>
    points == null ? "" : Number(points.toFixed(2)).toString();
